function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInvitationsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-invitations-normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3,0A3.94,3.94,0,1,1,2.36,3.94,3.94,3.94,0,0,1,6.3,0Zm4.51,8.22L9.06,7.78a4.73,4.73,0,0,1-5.51,0l-1.75.44A2.36,2.36,0,0,0,0,10.51v.91A1.18,1.18,0,0,0,1.18,12.6H11.42a1.18,1.18,0,0,0,1.18-1.18v-.91A2.36,2.36,0,0,0,10.81,8.22Zm6.85-2.79H15.73V3.49a.34.34,0,0,0-.34-.34H14.31a.34.34,0,0,0-.34.34V5.42H12a.34.34,0,0,0-.34.34V6.84a.34.34,0,0,0,.34.34H14V9.11a.34.34,0,0,0,.34.34h1.07a.34.34,0,0,0,.34-.34V7.18h1.94A.34.34,0,0,0,18,6.84V5.76a.34.34,0,0,0-.34-.34Z",
    style: {
      fill: "#999"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvitationsNormal);
export default __webpack_public_path__ + "static/media/icon-invitations-normal.30c72e52644630f1c899314c413b89f5.svg";
export { ForwardRef as ReactComponent };